module.exports = __webpack_public_path__ + "static/media/warranty_2.6933fa0a.pdf";